import React, {useState, useEffect} from 'react';
import api from '../contexts/BaseUrl'
import './Attendance.css'
import LeftPanel from '../components/LeftPanel';
import SearchIcon from '../icons/SearchIcon';
import CrossIcon from '../icons/CrossIcon';
import {Spinner} from 'react-activity'
import "react-activity/dist/library.css";
import Loading from '../components/Loading';
import { useCallback } from 'react';


function Attendance(){

    const token = JSON.parse(localStorage.getItem('auth')).token;
    

    const [addSale, setAddSale ]= useState(0);
    const [editSale,setEditSale] = useState(0);
    const [editSaleDetails, setEditSaleDetails] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [isDeleteError, setIsDeleteError] = useState(false);
    const [isDeleteLoading, setIsDeleteLoading] = useState(false);
    const [isEditLoading, setIsEditLoading] = useState(false);

    const [allSales, setAllSales] = useState([]);
    const [saleId, setSaleId] = useState(0);

    //search variable
    const [searchSalesAssignedTo, setSearchSalesAssignedTo] = useState('');
    const [dateFrom, setDateFrom] = useState('')
    const [dateTo, setDateTo] = useState('');

    const dateFromObj = dateFrom ? new Date(dateFrom) : null;
    const dateToObj = dateTo ? new Date(dateTo) : null;
    
    const [pageNumber, setPageNumber] = useState(1);
    const [pagination, setPagination] = useState([]);

    //add new sale variable
    const [selectedDate, setSelectedDate] = useState('');
    const selectedDateObj = selectedDate ? new Date(selectedDate) : null;
    
    
    
    const [salesArea, setSalesArea] = useState('');
    

  
   

  
    var url;

    if(dateFromObj != null && dateToObj != null && searchSalesAssignedTo.length>0){
        url = `attendances/get-all-attendances?description=${searchSalesAssignedTo}&fromDate=${dateFrom}&toDate=${dateTo}&pageNumber=${pageNumber}&pageSize=20`
    }
    else if(dateFromObj != null && dateToObj != null){
        url = `attendances/get-all-attendances?fromDate=${dateFrom}&toDate=${dateTo}&pageNumber=${pageNumber}&pageSize=20`
    }
    else if(dateFromObj != null && searchSalesAssignedTo.length>0){
        url = `attendances/get-all-attendances?description=${searchSalesAssignedTo}&fromDate=${dateFrom}&pageNumber=${pageNumber}&pageSize=20`
    }
    else if(dateFromObj != null){
        url = `attendances/get-all-attendances?fromDate=${dateFrom}&pageNumber=${pageNumber}&pageSize=20`
    }
    else if(searchSalesAssignedTo.length>0){
        url = `attendances/get-all-attendances?description=${searchSalesAssignedTo}&pageNumber=${pageNumber}&pageSize=20`
    }
    else{
        url = `attendances/get-all-attendances?pageNumber=${pageNumber}&pageSize=20` ;
    }


    const handlePageNext = () =>{
        if(pagination.totalPages>pagination.currentPage){
            setPageNumber(pageNumber+1)
        }     
    }

    const handlePagePrevious = () =>{
        if(pageNumber>1){
            setPageNumber(pageNumber-1);
        }
    }

   
    const fetchAllSales = useCallback(async () => {
        setIsLoading(true);
        await api.get(url,{
            headers: {Authorization: `Bearer ${token}`}
        }).then(response => {
            setAllSales(response.data);
            setIsLoading(false);
            setPagination(JSON.parse(response.headers.pagination));
        }).catch(err =>{
            setIsLoading(false);
        })
    },[url, token])

    const fetchSaleDetails = (e) => {
        setIsEditLoading(true);
        api.get(`attendances/get-attendance-details?attendanceId=${e}`,{
            headers: {Authorization: `Bearer ${token}`}
        }).then(response => {
            setSaleId(response.data.attendanceId);
            setSelectedDate(response.data.attendanceDate);
            setSalesArea(response.data.attendanceDescription);
           
            setIsEditLoading(false);
        }).catch(err =>{
            setIsEditLoading(false);
        })
    }

    useEffect(() => {
       fetchAllSales();
    },[fetchAllSales])


    const closeAddSale = () => {
       
        setSelectedDate('');
        setSalesArea('');
        setAddSale(0);
    }

    const handleAddSales = async (e) => {
        
        e.preventDefault();
        setIsLoading(true);

        await api.post(`attendances/create-attendance`,{
            attendanceDate: selectedDateObj,
            
            attendanceDescription: salesArea,
           
        },{
            headers:{
                Authorization: `Bearer ${token}`
            }
        }).then(response => {
            fetchAllSales();
            setIsLoading(false);
            setSelectedDate('');
            setSalesArea('');
            
            setAddSale();
            setIsError(false);
        }).catch(err =>{
            setIsError(true);
            setIsLoading(false);
            setSelectedDate('');
            setSalesArea('');
           
        })
    }

    const showEditSale = (e) => {
        fetchSaleDetails(e);
        setEditSaleDetails(1);
    }

    const closeEditSale = () => {
        setSelectedDate('');
        setSalesArea('');
       
        setIsEditLoading(false);
        fetchAllSales();
        setEditSaleDetails(0);
    }

    const handleEditSale = async (e) => {
        e.preventDefault();
        setIsEditLoading(true);
        await api.post(`attendances/edit-attendance`,{
            attendanceId: saleId,
            
            attendanceDescription: salesArea,
            
        },{
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then(response => {
            setSelectedDate('');
            setSalesArea('');
           
            fetchAllSales();
            setEditSaleDetails(0);
        }).catch(err => {
            setIsError(true);
            //setIsLoading(false);
            setSelectedDate('');
            setSalesArea('');
            
        })
    }

    const handleDeleteSale = async (e) => {
        e.preventDefault();
        setIsDeleteLoading(true);
        await api.get(`attendances/delete-attendance?attendanceId=${saleId}`,{
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then(response => {
            setSelectedDate('');
            setSalesArea('');
           
            setIsDeleteLoading(false);
            fetchAllSales();
            setEditSaleDetails(0);
        }).catch(err => {
            setIsDeleteError(true);
            setIsDeleteLoading(false);
            setSelectedDate('');
            setSalesArea('');
           
            
           
            
        })
    }
 
    return(
        <div className='salesPage'> 
    
           <LeftPanel 
                tabName='attendance'
           />
           <div id='rightPanel'>
                <div id='rightPanelContent'>
                    <div id='searchAddBox'>
                        <div className='dateBox'>
                            <input
                                type='date' 
                                className='dateInput'
                                onChange={e => setDateFrom(e.target.value)}
                                value={dateFrom}
                            />
                            <div id='to'>To</div>
                            <input
                                type='date' 
                                className='dateInput'
                                onChange={e => setDateTo(e.target.value)}
                                value={dateTo}
                            />

                            <div id='searchBox'>
                                <SearchIcon 
                                    size='24' 
                                    style={{
                                        paddingLeft:10,
                                        paddingTop:8,
                                        position:'absolute',
                                    }} 
                                    color='gray'
                                />
                                <input
                                    placeholder='Search by description'
                                    id='searchSales'
                                    onChange={(e) => setSearchSalesAssignedTo(e.target.value)}
                                    value={searchSalesAssignedTo}
                                />
                            </div>
                        </div>
                       <div>{
                           editSale === 0 ?
                           <button 
                                id='editButton'
                                onClick={() => setEditSale(1)}
                            >Edit</button>
                       :
                            <button 
                                id='editCancelButton'
                                onClick={() => setEditSale(0)}
                            >Cancel Edit</button>
                           }
                           
                            <button 
                                id='addButton'
                                onClick={() => setAddSale(1)}
                            >Add Attendance</button>
                       </div>
                        
                    </div>
                    <div id='tableBox'>
                        {isLoading ? 
                        <Loading /> :
                        <table>
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    
                                    <th>Description</th>
                                    
                                    {editSale === 1 && <th>Actions</th>}
                                </tr>
                            </thead>
                            <tbody>
                            {allSales.map((item, index) =>{
                                return(
                                    <tr key={index}>
                                        <td>{item.attendanceDate.slice(0,10)}</td>
                                        
                                        <td>{item.attendanceDescription}</td>
                                        
                                        {editSale ===1 && <td onClick={() => showEditSale(item.attendanceId)} style={{cursor:'pointer'}}>Edit</td>}
                                        
                                    </tr>
                                )
                            })}
                            </tbody>

                        </table>
                    }
                    <div id='pageChangeBox'>
                        <div id='fixedBox'>
                            <button id='pageChangeButton' onClick={handlePagePrevious}>Back</button>
                            
                            <span>{pageNumber} / {pagination.totalPages}</span>
                            <button id='pageChangeButton' onClick={handlePageNext}>Next</button>
                        </div>    
                        
                    </div>
                    </div>
                </div>
           </div>
           {
               addSale === 1 && 
               <>
                <div id='darkBackground' />
                <div id='modal'>
                    <CrossIcon 
                        size='36'
                        style={{
                            position:'absolute',
                            right:0,
                            cursor:'pointer'
                        }}
                        onClick={closeAddSale}
                    />
                    <form id='modalContent' onSubmit={handleAddSales}>
                        <div id='modalName'>Add New Attendance</div>
                        <div id='namePhone'>
                            <div id='name'>
                                <div id='nameTitle'>Date:</div>
                                <input
                                    id='typeName'
                                    type='date'
                                    required
                                    onChange={(e) => setSelectedDate(e.target.value)}
                                    value={selectedDate}
                                />
                            </div>
                            
                        </div>
                        <div id='namePhone'>
                            <div id='name'>
                                <div id='addressTitle'>Description:</div>
                                <textarea
                                    rows="4"
                                    cols="25"
                                    id='typeAddress'
                                    placeholder='Type Attendance Description'
                                    required
                                    onChange={(e) => setSalesArea(e.target.value)}
                                    value={salesArea}
                                />
                            </div>
                           
                        </div>
                           
                         
                        
                          
                        {isError && 
                            <div id='errorMsg'>Failed adding new attendance! Please try again later.</div>
                        }
                        {isLoading ? 
                    <button id='addEmployee'><Spinner size={12} color='black' style={{display:'block', margin:'auto'}} /></button>    :
                    <button id='addEmployee'>Add Attendance</button>
                    }
                       
                    </form>
                </div>
               </>
           }
            {
               editSaleDetails === 1 && 
               <>
                <div id='darkBackground' />
                <div id='modal'>
                    {isEditLoading ? 
                    <Loading /> :
                    
                    <div>
                    <CrossIcon 
                        size='36'
                        style={{
                            position:'absolute',
                            right:0,
                            top:0,
                            cursor:'pointer'
                        }}
                        onClick={closeEditSale}
                    />
                    <form id='modalContent' onSubmit={handleEditSale}>
                        <div id='modalName'>Edit Attendance</div>
                        <div id='namePhone'>
                            <div id='name'>
                                <div id='nameTitle'>Date:</div>
                                <div>{selectedDate.slice(0,10)}</div>
                            </div>
                            
                        </div>
                        <div id='namePhone'>
                            <div id='name'>
                                <div id='addressTitle'>Description:</div>
                                <textarea
                                    rows="4"
                                    cols="25"
                                    id='typeAddress'
                                    placeholder='Type Address Here'
                                    required
                                    onChange={(e) => setSalesArea(e.target.value)}
                                    value={salesArea}
                                />
                            </div>
                           
                        </div>
                        
                            
                           
                         
                        
                        {isError && 
                            <div id='errorMsg'>Failed updating attendance! Please try again later.</div>
                        }
                        {isDeleteError && 
                            <div id='errorMsg'>Failed deleting attendance! Please try again later.</div>
                        }
                        {isEditLoading ? 
                    <button id='addEmployee'><Spinner size={12} color='black' style={{display:'block', margin:'auto'}} /></button>    :
                    <button id='addEmployee'>Update Attendance</button>
                    }
                    
                    </form>
                    {isDeleteLoading ?    
                        <button id='deleteSale'><Spinner size={12} color='black' style={{display:'block', margin:'auto'}} /></button>    :
                        <button id='deleteSale' onClick={handleDeleteSale} >Delete</button>
                    }
                    </div>
                    }
                </div>
               </>
           }
          

        </div>
    )
}

export default Attendance;